import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { Turnstile } from '@marsidev/react-turnstile';

// Get site key from environment variable
const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || '0x4AAAAAAB03xSZ-1HudeIul';

const TurnstileWidget = forwardRef(({ onVerify, onError, onExpire, className = '' }, ref) => {
  const turnstileRef = useRef(null);

  useImperativeHandle(ref, () => ({
    reset: () => {
      if (turnstileRef.current) {
        turnstileRef.current.reset();
      }
    }
  }));

  const handleVerify = (token) => {
    console.log('Turnstile verified:', token);
    if (onVerify) onVerify(token);
  };

  const handleError = (error) => {
    console.error('Turnstile error:', error);
    if (onError) onError(error);
  };

  const handleExpire = () => {
    console.log('Turnstile token expired');
    if (onExpire) onExpire();
  };

  return (
    <div className={`turnstile-container ${className}`} style={{ position: 'relative', zIndex: 9999, minHeight: '65px' }}>
      <Turnstile
        ref={turnstileRef}
        siteKey={TURNSTILE_SITE_KEY}
        onSuccess={handleVerify}
        onError={handleError}
        onExpire={handleExpire}
        options={{
          theme: 'light',
          size: 'normal',
          action: 'submit-form',
          appearance: 'always',
          retry: 'auto',
          'retry-interval': 8000,
          'response-field': false,
          'error-callback': handleError,
          'expired-callback': handleExpire,
        }}
      />
    </div>
  );
});

TurnstileWidget.displayName = 'TurnstileWidget';

export default TurnstileWidget;
